import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { colors, breakpoints } from "../../../assets/styles/GlobalStyles";
import LOGO from "../../../assets/images/logo-oabms.png";
import Menu from "../Menu/Menu";
import { rolarParaTopo } from "../../../utils/rolarParaTopo";

const HeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
`;

const HeaderContainer = styled.header`
  background: linear-gradient(135deg, ${colors.blueDark} 0%, ${colors.blueMedium} 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  padding: 0 32px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.02);
  position: relative;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;

  @media (max-width: ${breakpoints.mobile}) {
    height: 68px;
    padding: 0 24px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  @media (max-width: 480px) {
    height: 56px;
    padding: 0 16px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;

  @media (max-width: ${breakpoints.mobile}) {
    gap: 12px;
  }

  @media (max-width: ${breakpoints.small}) {
    gap: 10px;
  }
`;

const LogoImage = styled.img`
  height: 52px;
  width: auto;
  flex-shrink: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));

  &:hover {
    transform: scale(1.02);
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));
  }

  @media (max-width: ${breakpoints.mobile}) {
    height: 42px;
  }

  @media (max-width: 480px) {
    height: 36px;
  }
`;

// Esconde o título em mobile pequeno (<480px) para economizar espaço; logo e menu continuam visíveis
const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
  min-width: 0;

  @media (max-width: ${breakpoints.small}) {
    display: none;
  }
`;

const TitleMain = styled.h1`
  color: ${colors.white};
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.3px;
  line-height: 1.3;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: linear-gradient(135deg, ${colors.white}, rgba(255, 255, 255, 0.9));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 18px;
  }

  // Entre 481-640px divide espaço com o nome do usuário: uma linha só, com reticências
  @media (max-width: 640px) {
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;

  @media (max-width: ${breakpoints.mobile}) {
    gap: 12px;
  }
`;

// O logo sempre leva pra Home (na própria Home, só volta pro topo). Fica aqui,
// e não em cada página, porque o Header é renderizado tanto pelo
// ProtectedLayout (App.js) quanto pelo MainLayout de cada página.
function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = () => {
    if (location.pathname === '/home') {
      rolarParaTopo();
    } else {
      navigate('/home');
    }
  };

  return (
    <HeaderWrapper>
      <HeaderContainer>
        <LeftSection>
          <LogoImage
            src={LOGO}
            alt="Logo OABMS — ir para a página inicial"
            title="Ir para a página inicial"
            onClick={handleLogoClick}
            style={{ cursor: 'pointer' }}
          />
          <TitleContainer>
            <TitleMain>Central de Solicitações OAB/MS</TitleMain>
          </TitleContainer>
        </LeftSection>

        <RightSection>
          <Menu />
        </RightSection>
      </HeaderContainer>
    </HeaderWrapper>
  );
}

export default Header;
